import fr from 'facet-rest';
import {
  initializeCollection,
  submitResource as submitResourcePagedCollectionContext,
} from 'Context/PagedCollectionContext';
import history from 'State/history';
import Panic from 'Errors/Panic';

export async function deleteResource(selectionDispatch, selectionState, listDispatch, resource) {
  const { queryValName } = selectionState;

  try {
    // Delete client returns null as data which blows up facet rest
    await resource.delete();
    listDispatch({ type: 'deleteResource', resource });
  } catch (err) {
    throw new Panic('client-delete-failed', 'A user failed to delete a client', {
      err,
    });
  }

  selectionDispatch({ type: 'unselectResource' });

  const url = new URL(window.location.href);
  url.searchParams.delete(queryValName);

  history.push({
    pathname: url.pathname,
    search: url.search,
  });
}

export function selectResource(selectionDispatch, selectionState, resource, collection) {
  const {
    getSelfLink,
    queryValName,
    metaOverride,
  } = selectionState;

  const selfLinkUrl = getSelfLink(resource);

  const exportedResource = resource.copy().export();
  exportedResource.meta = collection.meta().export();
  let selectedResource = fr.resource(exportedResource);

  if (metaOverride) {
    selectedResource = selectedResource.overrideMeta(metaOverride);
  }

  selectionDispatch({
    type: 'selectResource',
    selectedResource,
  });

  const url = new URL(window.location.href);
  url.searchParams.set(queryValName, selfLinkUrl);

  history.push({
    pathname: url.pathname,
    search: url.search,
  });
}

export function unselectResource(selectionDispatch, selectionState) {
  selectionDispatch({
    type: 'unselectResource',
  });

  const { queryValName } = selectionState;

  const url = new URL(window.location.href);
  url.searchParams.delete(queryValName);

  history.push({
    pathname: url.pathname,
    search: url.search,
  });
}

export function updateListResource(listDispatch, updatedResource) {
  listDispatch({ type: 'updateResource', resource: updatedResource });
}

export function submitListResource(listDispatch, listState, resource, args) {
  return submitResourcePagedCollectionContext(listDispatch, listState, resource, args);
}

export function refreshList(listDispatch, listState) {
  return initializeCollection(listDispatch, listState.selfLink);
}
